<template>
    <!-- <div> -->
        <b-card bg-variant="dark">
            <div slot="header">
                Reporte de utilidades
            </div>
            <div class="reporte-utilidades">
                <div>
                    <label for="inicio-del-reporte">Inicio del reporte</label>
                    <b-form-datepicker id="inicio-del-reporte" :min="min" :max="max" v-model="data2send.inicio" class="mb-2"></b-form-datepicker>
                </div>
                <div>
                    <label for="fin-del-reporte">Fin del reporte</label>
                    <b-form-datepicker id="fin-del-reporte" :min="minEnd" :max="maxEnd" v-model="data2send.fin" :disabled="!data2send.inicio" class="mb-2"></b-form-datepicker>
                </div>
            </div>
            <b-row class="mt-3 pt-1" align-h="end">
                <b-col sm="6" md="6" lg="5"><b-button block variant="primary" @click="tryDownloadExcel()"><i class="fa fa-download"></i> Excel</b-button></b-col>
                <b-col sm="6" md="6" lg="5"><b-button block variant="warning" @click="tryDownloadPDF()"><i class="fa fa-cog"></i> PDF</b-button></b-col>
            </b-row>
        </b-card>
    <!-- </div> -->
</template>
<script>
    import { downloadFile } from "@/utils.js"
    import moment from 'moment'
    import axios from 'axios'

    let allowDateCap = false
    
    export default {
        methods: {
            tryDownloadExcel(){
                const uri = "reportes/utilidad/downloadexcel/" + this.data2send.inicio + "/" + this.data2send.fin;
                downloadFile("reporte-utilidades.csv", uri);
                // axios
                // .get( uri )
                // .then((response) => {
                //     con
                //     let encodedUri = encodeURI("data:text/csv;charset=utf-8," + response);
                //     var link = document.createElement("a");
                //     link.setAttribute("href", encodedUri);
                //     link.setAttribute("download", "reporte.csv");
                //     document.body.appendChild(link); // Required for FF
                //     link.click();
                // });
            },
            tryDownloadPDF() {
                axios.get("reportes/utilidad/downloadpdf/" + this.data2send.inicio + "/" + this.data2send.fin)
                .then((response) => {
                if (response.status) {
                    var link = document.createElement("a");
                    link.setAttribute("href", response.data);
                    link.setAttribute("download", "reporte.pdf");
                    link.setAttribute("target", "_blank");
                    document.body.appendChild(link); // Required for FF
                    link.click();
                }
                });
            }
        },
        computed: {
            minEnd(){
                return (allowDateCap) ? moment(this.data2send.inicio, 'YYYY-MM-DD').add(0, 'day').toDate() : null
            },
            maxEnd(){
                return (allowDateCap) ? moment(this.data2send.inicio, 'YYYY-MM-DD').add(14, 'day').toDate() : null
            }
        },
        data() {
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            
            // 15th two months prior
            const minDate = new Date(today)
            minDate.setFullYear(minDate.getFullYear() - 1)
            
            // 15th in two months
            const maxDate = new Date(today)
            maxDate.setDate(maxDate.getDate() + 6)
            
            return {
                min: (allowDateCap) ? minDate : null,
                max: (allowDateCap) ? maxDate : null,
                data2send: {
                    inicio: '',
                    fin: ''
                }
            }
        }
    }
</script>
<style lang="less">

</style>